// extracted by mini-css-extract-plugin
module.exports = {"path":"I18n-module--path--9e64c0","i18n":"I18n-module--i18n--02b448"};